import { render, staticRenderFns } from "./WindowPaneCount.vue?vue&type=template&id=9f65bc6c"
import script from "./WindowPaneCount.vue?vue&type=script&lang=ts"
export * from "./WindowPaneCount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports